const initialState = {
    breaking_news: "",
    sliders: [],
    banners: [],
    services: [],
    products: [],
    latest_articles: [],
    faqs: [],
    story: []
}

const UIReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'UI':
            return {
                ...state,
                breaking_news: action.data ? action.data.breaking_news : "",
                sliders: action.data ? action.data.sliders : [],
                banners: action.data ? action.data.banners : [],
                services: action.data ? action.data.services : [],
                products: action.data ? action.data.products : [],
                FAQs: action.data ? action.data.faqs : [],
                articles: action.data ? action.data.latest_articles : [],
                story: action.data ? action.data.story : []
            }
        default:
            return state
    }
}

export default UIReducer
